import {
  TableCell,
  TableRow,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import Styles from '../Styles/ListCustodiansStyles';
import ResearchCustodianListColumn from '../../../Models/custodian/research-custodian-list-column';
import { cellContainer } from './ResearchStyles';
import { useState } from 'react';

export default function ResearchCustodiansListTableRow({
  row,
  columns,
}: {
  row: any;
  columns: ResearchCustodianListColumn[];
}) {
  const [expandedText, setExpandedText] = useState<string | null>(null);
  const [expandedField, setExpandedField] = useState<string | null>(null);

  const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 1200,
    },
  });

  const handleShowMore = (fieldName: string, text: string) => {
    setExpandedField(fieldName);
    setExpandedText(text);
  };

  const handleCloseDialog = () => {
    setExpandedText(null);
    setExpandedField(null);
  };

  return (
    <>
      <TableRow sx={Styles.tableRowStyles}>
        {columns.map((col) => (
          <TableCell
            key={col.id}
            sx={{
              ...cellContainer,
              minWidth: col.width,
            }}
          >
            {/* Special handling for warnings column (or whichever column you choose) */}
            {col.fieldName === 'warnings' ? (
              row && row[col.fieldName] && row[col.fieldName].length > 150 ? (
                <>
                  <Typography sx={Styles.custodianTableCellStyles}>
                    {row[col.fieldName]?.slice(0, 100)}...
                    <Button
                      variant="text"
                      size="small"
                      onClick={() => handleShowMore(col.fieldName, row[col.fieldName])}
                      sx={{ 
                        ml: 0.5, 
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        minWidth: 'auto',
                        padding: '0 4px',
                        color: 'primary.main',
                        '&:hover': {
                          backgroundColor: 'transparent',
                          textDecoration: 'underline',
                        }
                      }}
                    >
                      More
                    </Button>
                  </Typography>
                </>
              ) : (
                <Typography
                  sx={Styles.custodianTableCellStyles}
                  dangerouslySetInnerHTML={{
                    __html: row[col.fieldName]?.replace(/\r?\n/g, '<br>') || '',
                  }}
                />
              )
            ) : col.maxDisplayLength ? (
              <CustomWidthTooltip
                title={
                  <Typography style={{ whiteSpace: 'pre-line' }}>
                    {row ? row[col.fieldName] : ''}
                  </Typography>
                }
              >
                <Typography sx={Styles.custodianTableCellStyles}>
                  {row ? row[col.fieldName]?.slice(0, col.maxDisplayLength) : ''}
                  {row[col.fieldName]?.length > col.maxDisplayLength ? '...' : ''}
                </Typography>
              </CustomWidthTooltip>
            ) : (
              <Typography
                sx={Styles.custodianTableCellStyles}
                dangerouslySetInnerHTML={{
                  __html: row
                    ? row[col.fieldName]?.replace(/\r?\n/g, '<br>')
                    : '',
                }}
              />
            )}
          </TableCell>
        ))}
        <TableCell />
      </TableRow>

      {/* Dialog for expanded text */}
      <Dialog
        open={Boolean(expandedText)}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {expandedField ? expandedField.replace(/([A-Z])/g, ' $1').trim() : ''}
        </DialogTitle>
        <DialogContent>
          <Typography 
            sx={{ 
              whiteSpace: 'pre-line',
              wordBreak: 'break-word'
            }}
          >
            {expandedText}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}